module.exports = __webpack_public_path__ + "static/smarthome-8d1fc21dfa209f54ad5623ab9469f1f8.svg";